import { useEffect, useState } from "react";
import useApi from "@/components/useApi";
import PropTypes from "prop-types";
import { Tooltip } from "@nextui-org/react";
import { getBusinessRouteScreen, showMaxFavoriteCharacterError } from "@/utils";
import { useRecombee } from "@/hooks";
import { useUserSettings } from "@next-platform/client-common-core";
import { Icon, IconVariants, IconSize } from "@next-platform/client-common-spicy-ui";
import useLocalizedLocation from "@/hooks/useLocalizedLocation";

const HeartIcon = ({ character, size = 20, setErrorModalVisible, setErrorModalMessage, isLiked = false }) => {
  const { pagePath } = useLocalizedLocation();
  const screenName = getBusinessRouteScreen(pagePath);
  const { sendUserInteractionAddBookmark, recombeeUserId } = useRecombee();
  const [liked, setLiked] = useState(isLiked);
  const { onUserLikebot, isLoading } = useUserSettings();

  const { errorData } = useApi();

  const handleClick = async () => {
    const isLiked = !liked;
    setLiked(isLiked);
    const likedBot = character?.id;
    await onUserLikebot(likedBot, screenName);
    if (isLiked) await sendUserInteractionAddBookmark(recombeeUserId, character?.id);
  };

  useEffect(() => {
    showMaxFavoriteCharacterError({
      errorData,
      setErrorModalMessage,
      setErrorModalVisible,
      setLiked,
    });
  }, [errorData, setErrorModalMessage, setErrorModalVisible, setLiked]);

  return (
    <>
      <Tooltip content={liked ? "Unlike" : "Like"}>
        <div onClick={!isLoading ? handleClick : undefined} className="cursor-pointer">
          {liked ? <Icon icon={IconVariants.FAVORITE} color="red" size={size} /> : <Icon icon={IconVariants.FAVORITE} size={size} />}
        </div>
      </Tooltip>
    </>
  );
};

HeartIcon.propTypes = {
  character: PropTypes.object,
  size: PropTypes.number,
  setErrorModalVisible: PropTypes.func,
  setErrorModalMessage: PropTypes.func,
};

export default HeartIcon;
